module.exports = __webpack_public_path__ + "static/img/address-empty.878decd8.png";